import { render } from "./PageHeader.vue?vue&type=template&id=dfd9fd9a"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
script.render = render

export default script